import {
  AppWindow,
  ArrowLeft,
  Blinds,
  Box,
  Bus,
  Cog,
  Columns3,
  Construction,
  Container,
  Cylinder,
  DoorClosed,
  Factory,
  Forklift,
  Hammer,
  LayoutGrid,
  Monitor,
  PanelTop,
  RectangleHorizontal,
  Server,
  SquareDashed,
  User,
  Users,
  Mouse,
  Wind,
  Wrench,
  Building2,
  Camera,
  Car,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  ClipboardPaste,
  Copy,
  Download,
  CopyPlus,
  DoorOpen,
  Ellipsis,
  Eye,
  EyeOff,
  Fence,
  FileText,
  Footprints,
  Frame,
  Glasses,
  Grid3x3,
  History,
  Info,
  LandPlot,
  Layers,
  LocateFixed,
  Lock,
  LockOpen,
  Map,
  Maximize,
  MousePointer2,
  Move,
  Move3d,
  Package,
  PanelLeft,
  PanelRight,
  PenLine,
  Plus,
  Redo2,
  RotateCcw,
  RotateCw,
  Route,
  Ruler,
  Save,
  Scissors,
  Search,
  Settings,
  SlidersHorizontal,
  SquareDashedMousePointer,
  SquarePlus,
  Sun,
  Trash2,
  Truck,
  Undo2,
  Upload,
  Warehouse,
  X,
  MessageSquare,
  Paperclip,
  SendHorizontal,
  Phone,
  PhoneOff,
  Mic,
  MicOff,
  Languages,
  type LucideIcon,
} from 'lucide-react';

/**
 * One icon set for the whole app: emoji and Unicode symbols render differently on every
 * platform, SVG icons look identical on Windows, macOS and iPad.
 */
const ICONS = {
  'arrow-left': ArrowLeft,
  box: Box,
  building: Building2,
  camera: Camera,
  car: Car,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  sortable: ChevronsUpDown,
  clipboard: ClipboardPaste,
  copy: Copy,
  'copy-plus': CopyPlus,
  door: DoorOpen,
  more: Ellipsis,
  eye: Eye,
  'eye-off': EyeOff,
  fence: Fence,
  file: FileText,
  frame: Frame,
  grid: Grid3x3,
  history: History,
  info: Info,
  plot: LandPlot,
  layers: Layers,
  lock: Lock,
  unlock: LockOpen,
  map: Map,
  maximize: Maximize,
  locate: LocateFixed,
  pointer: MousePointer2,
  move: Move,
  package: Package,
  'panel-left': PanelLeft,
  'panel-right': PanelRight,
  pen: PenLine,
  plus: Plus,
  redo: Redo2,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  route: Route,
  ruler: Ruler,
  save: Save,
  scissors: Scissors,
  search: Search,
  settings: Settings,
  sliders: SlidersHorizontal,
  select: SquareDashedMousePointer,
  'plus-square': SquarePlus,
  sun: Sun,
  trash: Trash2,
  truck: Truck,
  undo: Undo2,
  upload: Upload,
  download: Download,
  hall: Warehouse,
  close: X,
  user: User,
  users: Users,
  mouse: Mouse,
  bus: Bus,
  forklift: Forklift,
  container: Container,
  rack: Columns3,
  shelf: LayoutGrid,
  machine: Factory,
  cog: Cog,
  wrench: Wrench,
  hammer: Hammer,
  cabinet: Server,
  desk: Monitor,
  tank: Cylinder,
  gate: PanelTop,
  'rolling-gate': Blinds,
  'door-closed': DoorClosed,
  window: AppWindow,
  'window-band': RectangleHorizontal,
  dock: Construction,
  skylight: SquareDashed,
  vent: Wind,
  spacemouse: Move3d,
  walk: Footprints,
  vr: Glasses,
  chat: MessageSquare,
  paperclip: Paperclip,
  send: SendHorizontal,
  phone: Phone,
  'phone-off': PhoneOff,
  mic: Mic,
  'mic-off': MicOff,
  languages: Languages,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export function Icon({
  name,
  size = 16,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  const Svg = ICONS[name];
  return <Svg size={size} strokeWidth={1.75} className={className} aria-hidden focusable={false} />;
}

export const isIconName = (name: string): name is IconName => name in ICONS;
